import React from 'react';
import { Route } from 'react-router-dom';
import WissenPage from 'modules/wissen/pages/WissenPage';
import wissenReducer from 'modules/wissen/features/wissenSlice';

/**
 * Modul-Definition "Wissen" (wissen).
 *
 * Persoenliche Wissensbasis mit Notizen, Ordnern und Dateien. Alle Inhalte sind
 * Ende-zu-Ende verschluesselt (Zero-Knowledge): der Tresor wird lokal im Browser
 * per Passphrase (+ optionaler Schluesseldatei) entsperrt.
 *
 * Einziger Export des Moduls an das Portal (Registry in modules/index.js).
 */
const wissenModul = {
  id: 'wissen',
  name: 'Wissen',
  description:
    'Verschlüsselte Wissensbasis für Notizen, Ideen und Dateien – Ende-zu-Ende gesichert mit eigener Passphrase und optionalem Offline-Schlüssel.',
  path: '/projekte/wissen',
  icon: '🧠',
  gradient: 'from-emerald-400 to-teal-600',
  status: 'active',
  // Nur im gesicherten Modus (entsperrter Tresor) erreichbar/sichtbar.
  secured: true,
  reducers: {
    wissen: wissenReducer,
  },
  routes: <Route path="/projekte/wissen" element={<WissenPage />} />,
};

export default wissenModul;
